"use client";
import {useCampusContext} from "@/app/_components/contexts/CampusCookieContext";
import LoadingBox from "@/app/_components/decorations/LoadingBox";
import Course from "@/app/types/Course";
import Season from "@/app/types/Season";
import {LegacyCampus} from "@/shared/legacyTypes/fetchCampusTypes";

/**
 * The text in the course overview box that displays the tuition fee.
 *
 * Uses useCampusContext to get the campus cookie and update if it changes,
 * such as if the user selects a campus via the Available Sessions dropdown.
 */
export const TuitionText = ({
	course,
	allCampusesById,
}: {
	course: Course;
	allCampusesById: Record<string, LegacyCampus>;
}) => {
	const {campus, isLoading: isCampusLoading} = useCampusContext();

	if (isCampusLoading) {
		return (
			<>
				<hr className="border-gray-500" />
				<LoadingBox className="h-7 max-w-52" />
			</>
		);
	}

	if (!campus?.campusId) {
		return null;
	}
	const campusTuitionValues = allCampusesById[campus?.campusId];
	if (!campusTuitionValues) {
		return null;
	}
	const tuition =
		course.season === Season.ACADEMIC_YEAR
			? campusTuitionValues?.display_tuition_fee
			: campusTuitionValues?.summer_tuition_fee;
	const perTerm =
		course.season === Season.ACADEMIC_YEAR ? "per trimester" : "per student";
	return (
		<>
			<hr className="border-gray-500" />
			<p>
				<span className="font-bold text-h5">${tuition}</span>{" "}
				<span className="italic text-gray-600">{perTerm}</span>
			</p>
		</>
	);
};
